import { createSlice } from "@reduxjs/toolkit";
import { getBureau } from "./thunk";

export const initialState = {
    bureau: {
        id: '',
        name: '',
        contact_number: '',
        address: '',
        bureau_id: '',
        user_id: '',
        status: '',
        last_activity: '',
        created_at: '',
        updated_at: ''
    },
    error: "", // for error message
    loading: false,
    isUserLogout: false,
    errorMsg: false, // for error
};

const bureauSlice = createSlice({
    name: "bureau",
    initialState,
    reducers: {
        apiError(state, action) {
            state.error = action.payload.data;
            state.loading = true;
            state.isUserLogout = false;
            state.errorMsg = true;
        },
        updateBureau(state, action) {
            state.bureau = { ...state.bureau, ...action.payload };
            state.loading = false;
            state.errorMsg = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBureau.pending, (state) => {
                state.loading = true;
                state.errorMsg = null;
            })
            .addCase(getBureau.fulfilled, (state, action) => {
                console.log('Bureau data updated:', action.payload);
                state.bureau = action.payload.data;
                state.loading = false;
                state.errorMsg = false;
            })
            .addCase(getBureau.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
                state.errorMsg = true;
            });
    }
});

export const {
    updateBureau,
    apiError
} = bureauSlice.actions;

export default bureauSlice.reducer;
